import { apply, put } from 'redux-saga/effects';
import { errorNotification } from '../reducers/notification.reducers';
import {
  loadUiOptionsSucceeded,
} from '../reducers/app.reducers';

// eslint-disable-next-line import/prefer-default-export
export function* loadUiOptions(appApi) {
  try {
    const response = yield apply(
      appApi,
      appApi.loadUiOptions,
    );

    if (response.errorCode || response.exceptionMessage) {
      yield put(errorNotification(response.message || 'Failed to load ui options'));
    } else {
      yield put(loadUiOptionsSucceeded(response));
    }
  } catch (e) {
    yield put(errorNotification('Failed to load ui options'));
  }
}

